// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Triangle.View'
    , [
        'calculator_square_foot_triangle.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_triangle_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_triangle_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-triangle-basic"]': 'calculateBasicArea',
                'click [data-action="calculate-square-foot-triangle-heron"]': 'calculateHeronArea',
                'click [data-action="reset-basic"]': 'resetBasicFields',
                'click [data-action="reset-heron"]': 'resetHeronFields'
            }

            , calculateBasicArea: function calculateBasicArea() {
                //input fields
                var base = $('#square-foot-triangle-basic-base').val(),
                    height = $('#square-foot-triangle-basic-height').val();
                //output fields
                var area = $('#square-foot-triangle-basic-area');

                var result = (parseFloat(base) * parseFloat(height) * .5);

                area.val(result.toFixed(2));
            }

            , calculateHeronArea: function calculateHeronArea() {
                //input fields
                var sideA = $('#square-foot-triangle-heron-side-a').val(),
                    sideB = $('#square-foot-triangle-heron-side-b').val(),
                    sideC = $('#square-foot-triangle-heron-side-c').val();

                //output fields
                var area = $('#square-foot-triangle-heron-area');

                var s = (parseFloat(sideA) + parseFloat(sideB) + parseFloat(sideC)) / 2, // half of the triangles perimeter
                    h = s * (s - sideA) * (s - sideB) * (s - sideC),
                    result = Math.sqrt(h);

                area.val(result.toFixed(2));
            }

            , resetBasicFields: function resetBasicFields() {
                $('.calculator-square-foot-triangle-basic-input-fields').find('input:text').val('');
                $('.calculator-square-foot-triangle-basic-output-fields').find('input:text').val('');
            }

            , resetHeronFields: function resetHeronFields() {
                $('.calculator-square-foot-triangle-heron-input-fields').find('input:text').val('');
                $('.calculator-square-foot-triangle-heron-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
